import React, { useLayoutEffect, useRef, useState } from 'react';
import { useColorScheme } from '../../../../contexts/ColorSchemeContext';
import AlbumIntro from './AlbumIntro';
import RecoverableImage from '../../../../features/images/RecoverableImage';
import { albumHeroFade } from './albumHeroFade';
import './AlbumHero.css';
import { useContinuousHero } from '../../../../components/layout/ContinuousHero';

export default function AlbumHero({ album, reviews, adminActions }) {
  const { resolvedMode } = useColorScheme();
  const dark = resolvedMode === 'dark';
  const ref = useRef(null);
  const [height, setHeight] = useState(0);
  const [failedUrl, setFailedUrl] = useState(null);
  const image = album.imageUrl && failedUrl !== album.imageUrl ? album.imageUrl : null;
  useContinuousHero(ref, Boolean(image));
  const fadeMask = `linear-gradient(to bottom, ${albumHeroFade(height, dark)
    .map(({ offset, opacity }) => `rgba(0, 0, 0, ${opacity}) ${offset * 100}%`)
    .join(', ')})`;
  useLayoutEffect(() => {
    const element = ref.current;
    const measure = () => setHeight(element.getBoundingClientRect().height);
    measure();
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(measure);
      observer.observe(element);
      return () => observer.disconnect();
    }
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  return (
    <section ref={ref} className={`pp-album-hero${image ? ' has-artwork pp-continuous-hero' : ''}`}>
      {image && (
        <div className="pp-album-hero-background" aria-hidden="true">
          <img className="pp-album-backdrop-base" src={image} alt="" />
          <img className="pp-album-backdrop-detail" src={image} alt="" />
          <div className="pp-album-backdrop-tone" />
          <div className="pp-album-backdrop-vignette" />
          <div
            className="pp-album-backdrop-fade"
            style={{ maskImage: fadeMask, WebkitMaskImage: fadeMask }}
          />
        </div>
      )}
      <div className="pp-album-cover">
        {album.imageUrl ? (
          <RecoverableImage
            src={album.imageUrl}
            alt={album.title}
            onError={() => setFailedUrl(album.imageUrl)}
            onLoad={() => setFailedUrl(null)}
            fallback={
              <div className="pp-album-cover-fallback" role="img" aria-label={album.title}>
                postpop.
              </div>
            }
          />
        ) : (
          <div className="pp-album-cover-fallback" role="img" aria-label={album.title}>
            postpop.
          </div>
        )}
      </div>
      <div className="pp-album-info">
        <AlbumIntro
          key={`${album.albumSource}:${album.sourceId ?? album.id}`}
          album={album}
          reviews={reviews}
        />
        {adminActions}
      </div>
    </section>
  );
}
